// extracted by mini-css-extract-plugin
module.exports = {"backToLogin":"ResetPassword_backToLogin__1uH5T","requiredAsterisk":"ResetPassword_requiredAsterisk__3i-dN","searchButton":"ResetPassword_searchButton__2bgnR"};